import { render, staticRenderFns } from "./libraryView.vue?vue&type=template&id=508d0990"
import script from "./libraryView.vue?vue&type=script&lang=js"
export * from "./libraryView.vue?vue&type=script&lang=js"
import style0 from "./libraryView.vue?vue&type=style&index=0&id=508d0990&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports